import ApplicationController from "./application_controller";

// Blanks a target input (e.g. a publication date) so saving the form leaves
// the value empty. An empty publication date marks the record unpublished.
export default class ClearableController extends ApplicationController {
    static targets = ["input"]

    declare readonly inputTarget: HTMLInputElement

    clear() {
        this.inputTarget.value = ""
        this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
}
